'use client';

import { Category } from '@/lib/types';

export const CATEGORY_ICONS = [
  { id: 'wallet', label: 'Budget' },
  { id: 'home', label: 'Maison' },
  { id: 'groceries', label: 'Courses' },
  { id: 'transport', label: 'Transport' },
  { id: 'leisure', label: 'Loisirs' },
  { id: 'health', label: 'Santé' },
  { id: 'restaurant', label: 'Restaurant' },
  { id: 'income', label: 'Salaire' },
  { id: 'savings', label: 'Épargne' },
  { id: 'shopping', label: 'Shopping' },
  { id: 'bills', label: 'Factures' },
] as const;

type CategoryIconProps = {
  category?: Pick<Category, 'name' | 'color' | 'icon'> | null;
  icon?: string;
  color?: string;
  className?: string;
};

function IconPath({ icon }: { icon: string }) {
  switch (icon) {
    case 'home':
      return <path d="M3 10.5 12 3l9 7.5V21h-6v-6H9v6H3V10.5Z" />;
    case 'groceries':
      return <path d="M6 8h12l-1.2 11H7.2L6 8Zm2-4h8l2 4H6l2-4Zm2 8h4" />;
    case 'transport':
      return <path d="M5 16V7a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v9H5Zm2 0v3m10-3v3M7 9h10M8 13h.01M16 13h.01" />;
    case 'leisure':
      return <path d="M8 8h8l3 5v5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-5l3-5Zm2 5h4m-2-2v4m5-1h.01M7 14h.01" />;
    case 'health':
      return <path d="M12 21s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 5.6-7 10-7 10Zm0-9v4m-2-2h4" />;
    case 'restaurant':
      return <path d="M7 3v8m3-8v8M5 3v8a3 3 0 0 0 6 0V3m6 0v18m-3-9h6" />;
    case 'income':
      return <path d="M12 3v18m5-14H9.5a3.5 3.5 0 0 0 0 7H14a3.5 3.5 0 0 1 0 7H6m9-15 3 3-3 3" />;
    case 'savings':
      return <path d="M5 11a7 7 0 0 1 14 0v5a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-5Zm7-4v4l3 2M8 19v2m8-2v2" />;
    case 'shopping':
      return <path d="M6 8h12l1 13H5L6 8Zm3 0a3 3 0 0 1 6 0" />;
    case 'bills':
      return <path d="M7 3h10v18l-2-1-2 1-2-1-2 1-2-1V3Zm3 5h4m-4 4h4m-4 4h2" />;
    default:
      return <path d="M4 7h16v10H4V7Zm2 3h4m7 4h1M7 17v2m10-2v2" />;
  }
}

export function CategoryIcon({ category, icon, color, className = '' }: CategoryIconProps) {
  const resolvedIcon = icon ?? category?.icon ?? 'wallet';
  const resolvedColor = color ?? category?.color ?? '#3b9d55';

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full ${className}`}
      style={{ backgroundColor: `${resolvedColor}24`, color: resolvedColor }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <IconPath icon={resolvedIcon} />
      </svg>
    </span>
  );
}
